export { extractErrorMessage } from './error.js';
export { fetchPolicyLookup } from './fetchPolicyLookup.js';
export { isBot } from './isBot.js';
export { extractShipping } from './shipping.js';
export { logErrorToRelic, logImgLoadErrorToRelic } from './logToRelic.js';
import logger from './logger.js';
export { default as parseJSON } from './parseJSON.js';
export { getUrlWithLocale } from './url.js';
export { getCookie, getCookies, removeCookie, setCookie } from './cookies.js';
export { getCurrencyCode, getCurrencySign, isValidCurrencyCode } from './currency.js';
export { getStructuredData } from './schema.js';
export { restorerIntervals } from './cookieRestorer.js';
export { setOrganizationId, setUserCart, setUserInformation } from './salesforce.js';
export { computePrices, computedWithDiscount } from './staticPrices.js';
export { coreMiddleware } from './middleware.js';
export { d as dataLayerCheckoutAccor } from '../checkout-lyccjd9h.js';
export { d as dataLayerCartAccor, s as sendCartEventAccor } from '../cart-SVV9q5Ln.js';
export { d as dataLayerSearchAccor } from '../search-3gNCPr7T.js';
import { c as calculateDiscount } from '../helpers-kA_hdoOI.js';
import { formatProductName } from './product.js';
import { cloneDeep } from 'lodash';
export { d as dataLayerSelectItemAccor } from '../selectItem-PWuzvZX7.js';
export { d as dataLayerPurchaseAccor } from '../purchase-j0II6Zcj.js';
export { p as pageView } from '../pageView-EPLyidHy.js';
export { d as dataLayerFeaturedProductsAccor } from '../featuredProducts-00rJtoMw.js';
export { recoverFromShippingInfoError } from './cartRecovery.js';
import '../serverErrors-_VHsjhgw.js';
import './logToSlack.js';
import 'cookies-next';
import '../cookies-l-jEMp6P.js';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-YC9H491Y.js';
import 'react';
import '../context/index.js';
import 'next/server';
import '../index-Oip0gjfj.js';
import '../redirect-29kuluSI.js';
import 'lodash/get';
import '../paths-ZKN3m62_.js';
import '../product-_pRduMz7.js';
import 'next/router';
import './dataRouteFormat.js';
import './auth.js';

// Function: Pushes "eNews Subscription" event to dataLayer
// Specs:
// - This function should be called whenenever a user subscribes to the newsletter, on the checkout page, footer, lightbox, or account pages
// TODO: This function is not currently being used on the checkout page, but needs to be.
const dataLayerSubscriptionAccor = (source) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'eNews Subscription',
        event_category: 'eNews Subscription',
        event_action: 'Subscribe',
        event_label: source,
        event_value: 1,
    });
    logger('eNews Subscription event sent', { category: 'analytics' });
};

// Functions:
// 1. Adds productView to dataLayer
// 2. Pushes view_item event to dataLayer
// Specs:
// - For the productView, include the name, sku, and current price for the visited product page
// - For view_item event, include the sku and current price for the visited product page
//
// More Info: https://hotelsathome.atlassian.net/wiki/spaces/D2/pages/2995191809/DataLayer+Reference+for+Analytics+-+Adobe+Launch+and+Google+Tag+Manager#Category-Page
const dataLayerProductAccor = ({ product, affiliation, brand, siteFilters = null, itemListName, }) => {
    var _a, _b, _c, _d;
    window.dataLayer = window.dataLayer || [];
    if (product) {
        const { sku } = product;
        const name = product.name_en.product_name || product.name;
        const price = product.price_range.maximum_price.final_price.value || null;
        const categoryName = ((_a = [...product.name_en.categories].reverse()[0]) === null || _a === void 0 ? void 0 : _a.name_en) || '';
        window.dataLayer.productView = {
            products: [
                {
                    name,
                    sku,
                    price,
                    // category: '', Disabled: unable to accurately get categories from Magento
                },
            ],
        };
        const ga4Items = [
            {
                affiliation,
                index: 0,
                discount: calculateDiscount(product.price_range.maximum_price.regular_price.value, price),
                item_brand: brand,
                item_category: categoryName,
                item_id: sku,
                item_list_id: categoryName,
                item_list_name: itemListName,
                item_name: formatProductName({
                    name,
                    lang: 'en',
                    siteFilters: siteFilters || null,
                }),
                price,
                subscription: 'no',
            },
        ];
        const productCopy = cloneDeep(product);
        const relatedProductsOptions = [
            productCopy.related_products,
            (_d = (_c = (_b = productCopy.variants) === null || _b === void 0 ? void 0 : _b.sort((a, b) => b.product.price_range.maximum_price.regular_price.value -
                a.product.price_range.maximum_price.regular_price.value)[0]) === null || _c === void 0 ? void 0 : _c.product) === null || _d === void 0 ? void 0 : _d.related_products,
        ];
        const relatedProducts = relatedProductsOptions.find(el => (el === null || el === void 0 ? void 0 : el.length) > 0) || [];
        relatedProducts.forEach((relatedProduct, idx) => {
            var _a, _b;
            const relatedProductCategoryName = ((_a = [...relatedProduct.name_en.categories].reverse()[0]) === null || _a === void 0 ? void 0 : _a.name_en) || '';
            // push add-on to ga4Items
            ga4Items.push({
                affiliation,
                index: idx,
                discount: calculateDiscount(relatedProduct.price_range.maximum_price.regular_price.value, relatedProduct.price_range.maximum_price.final_price.value),
                item_brand: brand,
                item_category: relatedProductCategoryName,
                item_id: relatedProduct.sku,
                item_list_id: relatedProductCategoryName,
                item_list_name: itemListName,
                item_name: formatProductName({
                    name: ((_b = relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.name_en) === null || _b === void 0 ? void 0 : _b.product_name) || relatedProduct.name,
                    lang: 'en',
                    siteFilters: siteFilters || null,
                }),
                price: relatedProduct.price_range.maximum_price.final_price.value,
                subscription: 'no',
            });
        });
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item',
            event_value: price,
            event_items: [
                {
                    google_business_vertical: 'retail',
                    id: sku,
                },
            ],
            ecommerce: {
                currency: product.price_range.maximum_price.final_price.currency,
                value: price,
                items: ga4Items,
                item_list_name: itemListName,
            },
        });
        logger('productView updated & "view_item" event pushed to dataLayer', {
            category: 'analytics',
        });
    }
    else {
        logger('Product not found: productView not updated & "view_item" event not pushed to dataLayer', { category: 'analytics' });
    }
};

// Function: Pushes view_item_list event to dataLayer
// Specs:
// - This function should be called on the category page, after the category items have been loaded
//
// More Info: https://hotelsathome.atlassian.net/wiki/spaces/D2/pages/2995191809/DataLayer+Reference+for+Analytics+-+Adobe+Launch+and+Google+Tag+Manager#Category-Page
const dataLayerCategoryAccor = ({ affiliation, brand, categoryItems, itemListName, siteFilters = null, }) => {
    var _a, _b;
    window.dataLayer = window.dataLayer || [];
    if (categoryItems && categoryItems.length > 0) {
        // Filter out (category) items without sku
        const categoryItemsProducts = categoryItems.filter((item) => { var _a; return item.product_data && ((_a = item.product_data) === null || _a === void 0 ? void 0 : _a.sku); });
        if (categoryItemsProducts.length === 0)
            return;
        const eventItems = [];
        const ga4eventItems = [];
        let currency = null;
        for (let i = 0; i < categoryItemsProducts.length; i += 1) {
            const product = categoryItemsProducts[i].product_data;
            const productCategoryName = ((_a = [...product.name_en.categories].reverse()[0]) === null || _a === void 0 ? void 0 : _a.name_en) || '';
            const sku = (product === null || product === void 0 ? void 0 : product.sku) || null;
            if (!currency) {
                currency = product.price_range.maximum_price.final_price.currency;
            }
            if (sku) {
                eventItems.push({
                    google_business_vertical: 'retail',
                    id: sku,
                });
                const finalPrice = product.price_range.maximum_price.final_price.value;
                ga4eventItems.push({
                    affiliation,
                    discount: calculateDiscount(product.price_range.maximum_price.regular_price.value, finalPrice),
                    index: i,
                    item_brand: brand,
                    item_category: productCategoryName,
                    item_id: sku,
                    item_list_id: productCategoryName,
                    item_list_name: itemListName,
                    item_name: formatProductName({
                        name: ((_b = product.name_en) === null || _b === void 0 ? void 0 : _b.product_name) || product.name,
                        lang: 'en',
                        siteFilters: siteFilters || null,
                    }),
                    price: finalPrice,
                    subscription: 'no',
                });
            }
        }
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: 'view_item_list',
            event_value: null,
            event_items: eventItems,
            ecommerce: {
                currency,
                item_list_name: itemListName,
                items: ga4eventItems,
            },
        });
        logger('view_item_list event pushed to dataLayer', { category: 'analytics' });
    }
    else {
        logger('Product items not found; view_item_list event not pushed to dataLayer', {
            type: 'error',
            category: 'analytics',
        });
    }
};

// Function: Pushes "sign_up" event to dataLayer
// Specs:
// - This function should be called whenever a user registers for an account
const dataLayerRegisterAccor = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: 'sign_up',
        ecommerce: {
            method: 'site registration',
        },
    });
    logger('sign_up event sent', { category: 'analytics' });
};

// Function: Pushes add_to_wishlist event to dataLayer
// Specs:
// - This function should be called whenenever a user selects a payment method, on the checkout page
const dataLayerWishlistAccor = (items, siteFilters) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'add_to_wishlist',
        ecommerce: {
            currency: items[0].product.price_range.maximum_price.regular_price.currency,
            value: items[0].product.price_range.maximum_price.regular_price.value,
            items: items.map(item => ({
                item_name: formatProductName({
                    name: item.product.name,
                    lang: 'en',
                    siteFilters: siteFilters || null,
                }),
                // TODO: GA4 - For Kit and Configurable products, we need to add the parent product SKU to the item_id field
                item_id: item.product.sku,
                discount: item.product.price_gap.value,
                price: item.product.price_range.maximum_price.final_price.value,
                quantity: 1,
            })),
        },
    });
    logger('add_to_wishlist event sent', { category: 'analytics' });
};

export { dataLayerCategoryAccor, dataLayerProductAccor, dataLayerRegisterAccor, dataLayerSubscriptionAccor, dataLayerWishlistAccor, logger };
//# sourceMappingURL=index.js.map
